export  const routelinks =()=>{
return [
      "ViewAttachment","Meeting","AddMeeting","sourcequery","Refer",
      "urlqueryexec","KPIPendencyList","KPIPendency","KPI","SaveData",
      "ManagerQRScan","DynamicReport","UserProfile","Ticket","LeaderboardReport",
      "Home","EmpTimeline","TicketList","EmpApprovals","EmpLeaves",
      "WorkHistory","Activity","RedFlag","ToDoList","AIChatbot"
    ];
} 